export default {
  price_estimation: {
    title: 'Evaluarea proprietății',
    summary_title: 'Indicatori de sinteză',
    avg_label: 'Preț mediu',
    median_label: 'Preț median',
    models_title: 'Modelele Estimator24',
    not_ready: 'Evaluarea nu a fost încă efectuată',
    ai_prediction: 'Evaluare AI',
    market_range: 'Piață',
    price_label: 'Prețul proprietății',
    within_range: 'În intervalul pieței',
    above_range: 'Supraevaluat cu +{percent}%',
    below_range: 'Subevaluat cu −{percent}%'
  }
}
